// Copyright (C) Lembani Sakala - All rights reserved.
// Lembani Sakala.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.

import { useParams } from 'react-router-dom';
import { AdminLayout } from '../layout/AdminLayout';
import { EnquiryManagement } from './EnquiryManagement';
import { DashboardOverview } from './DashboardOverview';

export const AdminDashboard = () => {
  const { section } = useParams();

  return (
    <AdminLayout>
      {section === 'dashboard' && <DashboardOverview />}
      {section === 'enquiries' && <EnquiryManagement />}
      {section === 'bookings' && (
        <div>
          <h3>Booking Management</h3>
          <p>Coming soon...</p>
        </div>
      )}
      {section === 'users' && (
        <div>
          <h3>User Management</h3>
          <p>Coming soon...</p>
        </div>
      )}
    </AdminLayout>
  );
};
